"use client";

import Honeybadger from "@honeybadger-io/js";
import { useEffect } from "react";

export default function GlobalError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		Honeybadger.notify(error);
	}, [error]);

	return (
		<html lang="en">
			<body className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center font-sans">
				<h2 className="text-2xl font-semibold">Something went wrong</h2>
				<p className="text-gray-600 max-w-md">
					An unexpected error occurred. Please try again.
				</p>
				<button
					type="button"
					onClick={reset}
					className="rounded-md bg-black px-4 py-2 text-sm font-medium text-white hover:bg-gray-800"
				>
					Try again
				</button>
			</body>
		</html>
	);
}
